<template>
  <div>
    <b-row class="m-0">
      <b-col sm="6" class="p-0">
        <div class="card bg-light mb-3">
          <div class="card-header bg-dark text-white d-flex justify-content-between align-items-center">
            <h6 class="mb-0"><font-awesome-icon icon="edit" /> Update Record</h6>
            <a :href="$router.resolve({ name: 'Job Description OT and ND Computation', params: { id: id }}).href"
               target="_blank"
               rel="noopener noreferrer">
              <b-button variant="primary" size="sm">
                <font-awesome-icon icon="print" /> Print OT/ND Computation Table
              </b-button>
            </a>
          </div>
          <div class="card-body position-relative">
            <form-component @refresh="get"/>
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="card mb-3">
          <div class="card-header bg-dark text-white">
            <h6 class="mb-0"><font-awesome-icon icon="edit" /> Affected Manpower Rates</h6>
          </div>
          <div class="card-body position-relative">
            <b-row align-v="center" class="loader" v-if="is_saving">
              <b-col>
                <b-spinner></b-spinner>
                <br><br>
                <strong>Loading</strong>
              </b-col>
            </b-row>
            <table class="table table-bordered">
              <tr>
                <th>Name</th>
                <th class="text-center">Current Monthly Rate</th>
                <th class="text-center">Current Daily Rate</th>
              </tr>
              <tr v-for="manpower_history_log in manpower_history_logs">
                <td>{{manpower_history_log.manpower.full_name}}</td>
                <td class="text-right">{{manpower_history_log.formatted_monthly_rate.other_formats.format_1}}</td>
                <td class="text-right">{{manpower_history_log.formatted_daily_rate.other_formats.format_1}}</td>
              </tr>
            </table>

          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card mb-3">
          <div class="card-header bg-dark text-white">
            <h6 class="mb-0"><font-awesome-icon icon="edit" /> Affected Project Rates</h6>
          </div>
          <div class="card-body position-relative">
            <b-row align-v="center" class="loader" v-if="is_saving">
              <b-col>
                <b-spinner></b-spinner>
                <br><br>
                <strong>Loading</strong>
              </b-col>
            </b-row>
            <table class="table table-bordered">
              <tr>
                <th>Name</th>
                <th class="text-center">Project</th>
                <th class="text-center">Current Daily Rate</th>
              </tr>
              <tr v-for="manpower_item_log in manpower_item_logs">
                <td>{{manpower_item_log.manpower.full_name}}</td>
                <td>
                  {{manpower_item_log.project_location_structure_item.project_location_structure.project_location.project.title}}<br>
                  <small>
                    {{manpower_item_log.project_location_structure_item.project_location_structure.project_location.description}} |
                    {{manpower_item_log.project_location_structure_item.project_location_structure.description}} |
                    {{manpower_item_log.project_location_structure_item.description}}
                  </small>
                </td>
                <td class="text-right">{{manpower_item_log.formatted_daily_rate.other_formats.format_1}}</td>
              </tr>
            </table>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
    import FormComponent from './Form.vue';
    export default {
      components: {FormComponent},
      data() {
        return {
          'manpower_history_logs':[],
          'manpower_item_logs':[],
          is_saving:false,
          'id':''
        }
      },
      created(){
        if(typeof this.$route.params.id !== 'undefined'){

          this.id=this.$route.params.id;
          this.get();
        }
      },
      methods: {
        get(){
          this.is_saving=true;
          this.axios.get('maintenance/job_descriptions/links',{params:{id:this.$route.params.id}}).then(response => {
            this.manpower_history_logs=response.data.manpower_history_logs;
            this.manpower_item_logs=response.data.manpower_item_logs;
            this.is_saving=false;
          }).catch(error => console.log(error));
        },
      }
    }
</script>
